// Navbar.js
import React from 'react';
import logo from '../assets/tiply_logo_v5.png';

function TipNavbar() {
    return (
        <nav className="bg-white ">
            <div className="max-w-7xl mx-auto px-4 py-4 flex items-center">
                <img
                    src={logo}
                    alt="Logo"
                    className="h-9 w-auto mr-2"
                />
            </div>
        </nav>
    );
}

export default TipNavbar;